var _rect, _circle, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    rx: 8,
    fill: "#00D632",
    stroke: "#00B82B",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 12,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 36,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#00D632"
  }, "$")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 25,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#fff"
  }, "Cash")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#fff"
  }, "App")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashApp);
export default __webpack_public_path__ + "static/media/cash-app.530d2912a62d1e10e21d15d0eb67e76c.svg";
export { ForwardRef as ReactComponent };